import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import {initReactI18next} from "react-i18next";

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        backend: {
            // translation file path
            loadPath: "/assets/i18n/{{ns}}/{{lng}}.json",
        },
        lng: 'en',
        fallbackLng: "jp",
        debug: false,
        // add pages name here
        ns: ['seller','global','buyer'],
        // contetnt will not rendered until the  namespace (language file) loaded
        react: {
            wait: true,
            useSuspense: true
        }
    });

export default i18n;
